import { ComponentType, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { removeCollectionAsync } from '../../data-layer/collections/actions';
import { CollectionModel } from '../../data-layer/collections/types';
import { useDispatch } from '../../data-layer/useDispatch';
import { useOpenDialog } from '../ModalRoute';
import { DIALOGS } from '../constants';

interface WithCollectionCallbacksProps {
    onRemove?: VoidFunction;
    onEdit?: VoidFunction;
}

export function withCollectionCallbacks<T>(
    BaseComponent: ComponentType<T & WithCollectionCallbacksProps>,
): ComponentType<
    Omit<Pick<T, Exclude<keyof T, keyof WithCollectionCallbacksProps>>, 'collection'> & {
        collection: CollectionModel;
    }
> {
    return (props) => {
        const { collection, ...other } = props;
        const dispatch = useDispatch();
        const navigate = useNavigate();

        const openDialog = useOpenDialog();
        const onEdit = useCallback(
            () => openDialog(DIALOGS.EDIT_COLLECTION, { collectionId: collection.id }),
            [collection, openDialog],
        );
        const onRemove = useCallback(async () => {
            await dispatch(removeCollectionAsync(collection.id));
            navigate('/profile');
        }, [dispatch, collection.id, navigate]);

        return (
            // @ts-ignore
            <BaseComponent {...other} collection={collection} onRemove={onRemove} onEdit={onEdit} />
        );
    };
}
